import { types } from "../types";

const ThemeAction = {
    Theme: (theme) => {
        return { type: types.THEME, theme };
    },
    Themeing: (themeing) => {
        return { type: types.THEMEING, themeing };
    },
    NavigationMode: (mode) => {
        return { type: types.NAVIGATION_MODE, mode };
    }
};
export default ThemeAction;

export const UPDATE_THEME_FROM_EDITOR = 'UPDATE_THEME_FROM_EDITOR';

export const updateThemeFromEditor = (updatedTheme) => ({
    type: UPDATE_THEME_FROM_EDITOR,
    payload: updatedTheme,
});
